import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

export const useFetchAllManagements = ({ marvarApi, dispatch, onLogout, location }) => {
    
    const [dataManagements, setDataManagements] = useState([])
    
    const [loadingFetchAllManagements, setLoadingFetchAllManagements] = useState(false)
    
    const [execute, setExecute] = useState(0)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const lastPartUrl = location.pathname.split('/').pop()
    const status = lastPartUrl === 'activas' ? 1 : 0

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            // param 1: Gestiones Activas, 0: Gestiones Cerradas
            const response = await marvarApi.get(`/general-managements/fetch-all-managements/${status}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllManagements(true)
        fetchData()
            .then((resp) => {
                setDataManagements(resp.rows)
                setLoadingFetchAllManagements(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setDataManagements([])
                setLoadingFetchAllManagements(false)
            })
    }, [execute])

    return { dataManagements, loadingFetchAllManagements, executeFetch }
}

export const useFetchSpecificManagement = ({ marvarApi, dispatch, onLogout, Forms }) => {
    
    const _defaultParams = {
        idgestion: ''
    }

    const { FormScreen } = Forms
    const { setFormState } = FormScreen

    const [ loadingFetchSpecificManagement, setLoadingFetchSpecificManagement ] = useState(false)

    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/general-managements/fetch-specific-management/${paramsToSearch.idgestion}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idgestion > 0 ){
            setLoadingFetchSpecificManagement(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idgestion: rows[0].idgestion || '',
                        fecha: rows[0].fecha || '',
                        titulo: rows[0].titulo || '',
                        descripcion: rows[0].descripcion || ''
                    }))
                    setLoadingFetchSpecificManagement(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificManagement(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificManagement, setParamsToSearch, executeFetch }
}

// export const useFetchSpecificManagementv2 = ({ marvarApi, Forms, Helpers }) => {
    
//     const [ loadingFetchSpecificManagement, setLoadingFetchSpecificManagement ] = useState(false)
//     const { FormScreen } = Forms
//     const { setFormState } = FormScreen

//     const executeFetch = async (idgestion) => {
//         setLoadingFetchSpecificManagement(true)
//         try {
//             const response = await marvarApi.get(`/general-managements/fetch-specific-management/${idgestion}`)
//             const { data } = response

//             setFormState((prevState) => ({
//                 ...prevState,
//                 idgestion: data.rows[0].idgestion || '',
//                 fecha: data.rows[0].fecha || '',
//                 descripcion: data.rows[0].descripcion || ''
//             }))

//             setLoadingFetchSpecificManagement(false)
//             return true
//         } catch (e) {
//             console.log(e, '________ERROR')
//             setLoadingFetchSpecificManagement(false)
//             return false
//         }
//     }

//     return { loadingFetchSpecificManagement, executeFetch }
// }

export const useFetchAllLogs = ({marvarApi, dispatch, onLogout}) => {

    const [ paramsToSearch, setParamsToSearch ] = useState({
        idgestion: ''
    })

    const [ dataLogs, setDataLogs ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchLogs, setLoadingFetchLogs ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/general-managements/fetch-all-logs/${paramsToSearch.idgestion}`)
            console.log('[useFetchData][useFetchAllLogs] response.data ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idgestion !== '' ){
            setLoadingFetchLogs(true)
            fetchData()
                .then((resp) => {
                    setDataLogs(resp.rows)
                    setLoadingFetchLogs(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchLogs(false)
                })
        }
    }, [execute])

    return { dataLogs, loadingFetchLogs, executeFetch, setParamsToSearch }

}